import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { updateInterval: Number }
  
  connect() {
    this.startPolling()
  }
  
  disconnect() {
    this.stopPolling()
  }
  
  startPolling() {
    this.poll = setInterval(() => {
      this.updateStatuses()
    }, this.updateIntervalValue || 15000)
  }
  
  stopPolling() {
    if (this.poll) {
      clearInterval(this.poll)
    }
  }
  
  updateStatuses() {
    fetch('/operations/staff/status', {
      headers: {
        'Accept': 'text/html'
      }
    })
    .then(response => response.text())
    .then(html => {
      // Create a temporary element to parse the response
      const temp = document.createElement('div')
      temp.innerHTML = html
      
      // Update each staff card individually to maintain smooth animations
      temp.querySelectorAll('[data-staff-id]').forEach(newCard => {
        const staffId = newCard.dataset.staffId
        const existingCard = this.element.querySelector(`[data-staff-id="${staffId}"]`)
        
        if (existingCard) {
          // Check if status has changed
          const oldStatus = existingCard.dataset.staffStatus
          const newStatus = newCard.dataset.staffStatus
          
          if (oldStatus !== newStatus) {
            // Animate status change
            this.animateStatusChange(existingCard, newCard)
          } else {
            // Update content without animation
            existingCard.innerHTML = newCard.innerHTML
          }
        }
      })
    })
    .catch(error => {
      console.warn('Failed to update staff status:', error)
    })
  }
  
  animateStatusChange(existingCard, newCard) {
    // Add transition classes
    existingCard.classList.add('transition-all', 'duration-300')
    
    // Fade out briefly
    existingCard.style.opacity = '0.5'
    
    setTimeout(() => {
      // Update content
      existingCard.innerHTML = newCard.innerHTML
      existingCard.className = newCard.className
      
      // Fade back in
      existingCard.style.opacity = '1'
      
      // Remove transition classes after animation
      setTimeout(() => {
        existingCard.classList.remove('transition-all', 'duration-300')
      }, 300)
    }, 150)
  }
  
  assignStaff(event) {
    const staffId = event.currentTarget.closest('[data-staff-id]').dataset.staffId
    const layoutController = document.querySelector('[data-controller*="operations-layout"]')
    
    if (layoutController) {
      // Trigger quick booking with preselected staff
      const quickBookingEvent = new CustomEvent('open-quick-booking', {
        detail: { preselectedStaff: staffId }
      })
      layoutController.dispatchEvent(quickBookingEvent)
    }
  }
  
  startBreak(event) {
    const staffId = event.currentTarget.closest('[data-staff-id]').dataset.staffId
    this.updateStaffStatus(staffId, 'break')
  }
  
  endBreak(event) {
    const staffId = event.currentTarget.closest('[data-staff-id]').dataset.staffId
    this.updateStaffStatus(staffId, 'available')
  }
  
  updateStaffStatus(staffId, status) {
    fetch(`/operations/staff/${staffId}/status`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({ status: status })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        // Status will be updated on next poll cycle
        this.updateStatuses()
      } else {
        this.showError('Failed to update staff status')
      }
    })
    .catch(error => {
      console.error('Status update failed:', error)
      this.showError('Failed to update staff status')
    })
  }
  
  showError(message) {
    // Create a temporary error notification
    const notification = document.createElement('div')
    notification.className = 'fixed top-4 right-4 bg-red-500 text-white px-4 py-2 rounded-lg shadow-lg z-50'
    notification.textContent = message
    
    document.body.appendChild(notification)
    
    setTimeout(() => {
      notification.remove()
    }, 3000)
  }
}